import {
  SIGNUP_USER_SUCCESS,
  SIGNIN_USER_SUCCESS,
  SIGNOUT_USER_SUCCESS,
  SHOW_MESSAGE,
  HIDE_MESSAGE,
  ON_SHOW_LOADER,
  ON_HIDE_LOADER,
  INIT_URL,
  GET_USER_DATA
} from "../mutation-types";

export default {
  [SIGNUP_USER_SUCCESS]: ({ commit }) => {
    commit(SIGNUP_USER_SUCCESS);
  },
  [SIGNIN_USER_SUCCESS]: (
    { commit },
    { accessToken, refreshToken, expiresIn }
  ) => {
    commit(SIGNIN_USER_SUCCESS, { accessToken, refreshToken, expiresIn });
  },
  [GET_USER_DATA]: ({ commit }, userInfo) => {
    commit(GET_USER_DATA, userInfo);
  },
  [SIGNOUT_USER_SUCCESS]: ({ commit }) => {
    commit(SIGNOUT_USER_SUCCESS);
  },
  [SHOW_MESSAGE]: ({ commit }, message) => {
    commit(SHOW_MESSAGE, message);
  },
  [HIDE_MESSAGE]: ({ commit }) => {
    commit(HIDE_MESSAGE);
  },
  [ON_SHOW_LOADER]: ({ commit }) => {
    commit(ON_SHOW_LOADER);
  },
  [ON_HIDE_LOADER]: ({ commit }) => {
    commit(ON_HIDE_LOADER);
  },
  [INIT_URL]: ({ commit }, url) => {
    commit(INIT_URL, url);
  }
};
